import getCollection from './getCollection'
import getObject from './getObject'
import { setDoc } from 'firebase/firestore/lite'

const updateSettings = async (data) => setDoc(getCollection(), getObject(data), { merge: true })

export default updateSettings
